import ReactGA from 'react-ga4';
import { Select, InputLabel, FormControl, ListSubheader } from '@mui/material';
import { useStore } from 'react-admin';

import { ColorScheme, colorSchemeMap } from '@models/color-scheme';
import { colorSchemeItem, ColorMenuItem } from './color-menu-item';

export const ColorSchemeSelect = () => {
  const [colorSchemeId, setColorSchemeId] = useStore('map.imageColorSchemeId', 0);
  const [colorSchemeReverse] = useStore('map.imageColorSchemeReverse', false);

  const onSelect = (event: any) => {
    setColorSchemeId(event.target.value as number);

    // Send event to Google Analytics
    ReactGA.event('select_image_color_scheme', {
      category: 'ImageColorScheme',
      action: 'Select Image Color Scheme',
      label: colorSchemeMap[event.target.value].name,
      value: event.target.value,
    });
  };

  const groupedMenu = Object.values(colorSchemeMap).reduce((acc: { [key: string]: Array<ColorScheme> }, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  return (
    <FormControl sx={{ width: 250 }}>
      <InputLabel id='color-scheme-select-label'>Color Scheme</InputLabel>
      <Select
        defaultValue={colorSchemeId}
        labelId='color-scheme-select-label'
        onChange={onSelect}
        value={colorSchemeId}
        size={'medium'}
        variant='standard'
        style={{ marginTop: 25 }}
      >
        {Object.keys(groupedMenu).map((category) => [
          <ListSubheader key={category}>{category}</ListSubheader>,
          ...groupedMenu[category].map((colorScheme: ColorScheme) => (
            <ColorMenuItem
              key={colorScheme.id}
              value={colorScheme.id}
              colorScheme={colorScheme}
              colorSchemeReverse={colorSchemeReverse}
            >
              {colorSchemeItem(colorScheme, colorSchemeReverse)}
            </ColorMenuItem>
          ))
        ])}
      </Select>
    </FormControl>
  );
};
